module.exports = __webpack_public_path__ + "static/media/homepage-preview.18941b66.png";